import useAuth from 'hooks/useAuthContext';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, Navigate, Outlet } from 'react-router';
import { logoutUser } from 'store/reducers/actions';
import { logout } from 'store/reducers/userSlice';
import calculateExpirationTime from 'utils/functions/calculate-expiration-time';
import { decodeToken } from 'utils/functions/jwt-token';
import { getJwtToken } from 'utils/functions/session-storage';
import { redirect, useNavigate } from '../../node_modules/react-router/dist/index';

export default function RequireAuth({ allowedRoles, children, featureCode }) {
  const token = getJwtToken();
  const tokenData = decodeToken(token);
  // const role = tokenData?.user_type;
  const role = 'B';
  const location = useLocation();
  // const permissions = useSelector((state) => state.user.permissions);
  const permissions = JSON.parse(sessionStorage.getItem('permissions'));

  // return !allowedRoles?.includes(role) || !permissions.some((permission) => permission === featureCode) ? (
  //   <Navigate to="/login" state={{ from: location }} replace />
  // ) : (
  //   <>{children}</>
  // );

  return !allowedRoles?.includes(role) ? <Navigate to="/login" state={{ from: location }} replace /> : <>{children}</>;
}
